var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading_page",
      class: { loading_page__new: _vm.view == "purple" }
    },
    [
      _vm.view == "purple"
        ? [
            _c(
              "div",
              {
                staticClass: "app_content_new",
                attrs: { id: "app_content_new" }
              },
              [
                _c("div", { staticClass: "contained_app_content_new" }, [
                  _c(
                    "div",
                    { staticClass: "main_panel_new with_left_panel_new" },
                    [
                      _c("div", { staticClass: "main_panel_content_new" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "profile_section_new profile_section__info"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "email_progress_title_new" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.gathering_results_for"
                                    )
                                  ) + " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "profile_section_query_new",
                                    staticStyle: {
                                      direction: "ltr",
                                      display: "inline-block"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.searchTextShow))]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "email_progress_details_new " },
                              [
                                _vm._m(0),
                                _c("div", [
                                  _c("div", { staticClass: "verified" }, [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "12",
                                          height: "12",
                                          viewBox: "0 0 12 12",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M11 5.53999V5.99999C10.9994 7.0782 10.6502 8.12733 10.0047 8.99091C9.35908 9.85448 8.45164 10.4862 7.41768 10.7919C6.38371 11.0977 5.27863 11.0609 4.26723 10.6873C3.25584 10.3136 2.39233 9.62304 1.80548 8.71853C1.21863 7.81401 0.939896 6.74403 1.01084 5.66815C1.08178 4.59228 1.4986 3.56816 2.19914 2.74853C2.89968 1.9289 3.84639 1.35768 4.89809 1.12007C5.9498 0.882448 7.05013 0.991162 8.035 1.42999",
                                            stroke: "#A6F149",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M11 2L6 7.005L4.5 5.505",
                                            stroke: "#A6F149",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                    Verfied Result\n                  "
                                    )
                                  ]),
                                  _c("div", { staticClass: "search-record" }, [
                                    _vm._v(
                                      "\n                    WE'RE SEARCHING BILLIONS OF RECORDS\n                  "
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "email_progress_bar",
                                      attrs: { "data-reactroot": "" }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "email_progress_bar_inner",
                                        style: "width: " + _vm.progress + "%"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "email_progress_bar_percent text_jewel green_jewel"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.progress) +
                                              " %\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", {
                                  staticClass: "email_progress_bar_subtitle",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.searchTextBar)
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _c("div", { staticClass: "profile_section_new" }, [
                          _c("div", { staticClass: "profile_section__grid" }, [
                            _c(
                              "div",
                              { staticClass: "profile_section_title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.results_may_include"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "ul",
                              { staticClass: "results_may_include_items" },
                              [
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_1" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.full_address"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_2" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.relation_ship_status"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_3" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.location_history"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_4" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.phone_number"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_5" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.email_address"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_6" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.month_year_of_birth"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ]),
                _c("div", { staticClass: "new-home" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c(
                      "div",
                      { staticClass: "contained_app_content" },
                      [_c("testimonial")],
                      1
                    )
                  ])
                ])
              ]
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "app_content", attrs: { id: "app_content" } },
              [
                _c("div", { staticClass: "contained_app_content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sub_panel panel left",
                      attrs: { id: "sub_panel" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sub_panel_content panel_content",
                          attrs: { id: "sub_panel_content" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sub_panel_content_modules border" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "animate_map_container",
                                  attrs: { searching_map: "" }
                                },
                                [
                                  _c("div", { staticClass: "map1" }),
                                  _c("div", { staticClass: "map1_blurred" }),
                                  _c("div", { staticClass: "map2" }),
                                  _c("div", { staticClass: "map3" }),
                                  _c("div", { staticClass: "map4" }),
                                  _c("div", { staticClass: "ready_wrapper" }),
                                  _c("div", { staticClass: "ready_text" }),
                                  _c(
                                    "div",
                                    { staticClass: "foreground_wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "searching_text" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.searching"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._m(1),
                                      _c("div", {
                                        staticClass: "crosshair_hor"
                                      }),
                                      _c("div", {
                                        staticClass: "crosshair_ver"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "main_panel panel with_left_panel",
                      attrs: { id: "main_panel" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "main_panel_content panel_content",
                          attrs: { id: "main_panel_content" }
                        },
                        [
                          _c("div", { staticClass: "profile_section" }, [
                            _c("div", { staticClass: "email_progress_title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.gathering_results_for"
                                  )
                                ) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "profile_section_query",
                                  staticStyle: {
                                    direction: "ltr",
                                    display: "inline-block"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.searchTextShow))]
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "email_progress_subtitle" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.be_patient")
                                  ) + "\n              "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "email_progress_details" },
                              [
                                _vm._m(2),
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "email_progress_bar",
                                      attrs: { "data-reactroot": "" }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "email_progress_bar_inner",
                                        style: "width: " + _vm.progress + "%"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "email_progress_bar_percent text_jewel green_jewel"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.progress) +
                                              " %\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", {
                                  staticClass: "email_progress_bar_subtitle",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.searchTextBar)
                                  }
                                })
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "profile_section" }, [
                            _c(
                              "div",
                              { staticClass: "profile_section_title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.results_may_include"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "ul",
                              { staticClass: "results_may_include_items" },
                              [
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_1" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.full_address"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_2" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.relation_ship_status"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_3" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.location_history"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_4" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.phone_number"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_5" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.email_address"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "results_may_include_item waiting",
                                    attrs: { id: "results_may_include_6" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.month_year_of_birth"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "profile_section" }, [
                            _c(
                              "div",
                              { staticClass: "profile_section_title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.customer_testimonials"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "panels_3 user_testimonials" },
                              [
                                _c("div", { staticClass: "user_testimonial" }, [
                                  _c("i", {
                                    staticClass:
                                      "icon icon-quote icon_jewel circle_icon_jewel border_jewel blue_jewel testimonial_quote_icon"
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_text" },
                                    [
                                      _vm._v(
                                        '"' +
                                          _vm._s(
                                            _vm._f(
                                              "trans"
                                            )("st_public.testimonial1", {
                                              websitename: _vm.websiteName
                                            })
                                          ) +
                                          '"\n                  '
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.testimonial1_by"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "user_testimonial" }, [
                                  _c("i", {
                                    staticClass:
                                      "icon icon-quote icon_jewel circle_icon_jewel border_jewel blue_jewel testimonial_quote_icon"
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_text" },
                                    [
                                      _vm._v(
                                        '"' +
                                          _vm._s(
                                            _vm._f(
                                              "trans"
                                            )("st_public.testimonial2", {
                                              websitename: _vm.websiteName
                                            })
                                          ) +
                                          '"\n                  '
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.testimonial2_by"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "user_testimonial" }, [
                                  _c("i", {
                                    staticClass:
                                      "icon icon-quote icon_jewel circle_icon_jewel border_jewel blue_jewel testimonial_quote_icon"
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_text" },
                                    [
                                      _vm._v(
                                        '"' +
                                          _vm._s(
                                            _vm._f(
                                              "trans"
                                            )("st_public.testimonial3", {
                                              websitename: _vm.websiteName
                                            })
                                          ) +
                                          '"\n                  '
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "user_testimonial_name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.testimonial3_by"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email_progress_image" }, [
      _c("i", { staticClass: "email_progress_image_icon icon-lock" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "utc_time_text", staticStyle: { display: "none" } },
      [
        _vm._v("\n                    UTC\n                    "),
        _c(
          "span",
          { staticClass: "ng-isolate-scope", attrs: { time_zone: "UTC" } },
          [_vm._v("09:30:55")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email_progress_image" }, [
      _c("i", { staticClass: "email_progress_image_icon icon-lock" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f1cf5fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1cf5fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/LoadingData.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0f1cf5fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/LoadingData.vue
// module chunks = 2 3 4 5 6 7 8